// extracted by mini-css-extract-plugin
module.exports = {"home1":"home1_home1__jSR92"};